export const BASE_OPTION_PADDING = 28;

export const SELECT_MODE = {
  SINGLE: "single",
  MULTIPLE: "multiple",
};

export const DIR_DIRECTION = {
  LTR: "ltr",
  RTL: "rtl",
};

export const SELECT_VARIANT = {
  DEFAULT: "default",
  GHOST: "ghost",
};
